import {
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Tooltip
} from '@mui/material'
import PropTypes from 'prop-types'
import { Link, useMatch } from 'react-router-dom'
import useTerminology from '@/hooks/useTerminology'

export function SidebarItem({ item, collapsed, sx }) {
    const { t } = useTerminology()
    const label = item.termKey ? t(item.termKey) : item.label
    const match = useMatch({
        path: item.path,
        end: item.matchSubpaths === false || item.path === '/'
    })
    const isActive = !!match

    return (
        <Tooltip
            title={collapsed ? label : ''}
            placement="right"
            enterDelay={0}
        >
            <ListItemButton
                component={Link}
                to={item.path}
                selected={isActive}
                aria-current={isActive ? 'page' : undefined}
                data-tour={`nav-${item.id}`}
                sx={[
                    {
                        minHeight: 48,
                        px: 2.5,
                        justifyContent: collapsed ? 'center' : 'flex-start'
                    },
                    ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
                ]}
            >
                <ListItemIcon
                    sx={{
                        minWidth: 0,
                        mr: collapsed ? 0 : 2,
                        justifyContent: 'center',
                        color: isActive ? 'primary.main' : 'inherit'
                    }}
                >
                    {item.icon}
                </ListItemIcon>
                {!collapsed && (
                    <ListItemText
                        primary={label}
                        slotProps={{
                            primary: {
                                fontWeight: isActive ? 600 : 400,
                                color: isActive
                                    ? 'primary.main'
                                    : 'text.primary'
                            }
                        }}
                    />
                )}
            </ListItemButton>
        </Tooltip>
    )
}

SidebarItem.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
        icon: PropTypes.element.isRequired,
        matchSubpaths: PropTypes.bool
    }).isRequired,
    collapsed: PropTypes.bool.isRequired,
    sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}
